import * as analytics from '@anm/analytic';
import { DEFAULT_PAGE } from '@anm/data/video-templates/defaults';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import dispatchPageContent from '../../../helpers/videoTemplates/dispatchPageContent';
import routes from '../../../routes';
import { filterSelectors } from '../../../store/modules/filter';
import {
  templateActions,
  templateSelectors
} from '../../../store/modules/template';

import { getRouterParams } from './helpers';

export const useModelCloseHandler = () => {
  const { Router } = routes;
  const dispatch = useDispatch();
  const pageName = useSelector(templateSelectors.selectTemplatePage);
  const { aspects = '' } = useSelector(filterSelectors.selectSavedFilters);

  const [route, params] = getRouterParams(pageName || DEFAULT_PAGE, aspects);

  const handleModalClose = useCallback(() => {
    dispatch(templateActions.clearCurrentTemplate());

    Router.pushRoute(route, params, { shallow: true });
  }, [route, pageName, aspects]);

  useEffect(() => {
    window.onpopstate = handleModalClose;

    !pageName &&
      dispatchPageContent({ dispatch, query: { pageName: DEFAULT_PAGE } });

    return () => {
      window.onpopstate = null;
    };
  }, []);

  return handleModalClose;
};

export const useTrackEvents = () => {
  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);

  useEffect(() => {
    if (!currentTemplate) return;

    const { templateId, displayName } = currentTemplate;
    analytics.trackTemplateView(displayName, templateId);
  }, [currentTemplate]);
};
